module.exports = __webpack_public_path__ + "static/udmurtRepUprav-ed5d7b47cbd91c3b03037146cb63b76b.jpg";